import {Component, Inject, isDevMode} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

import {NewNavigationService} from "@shared/services/new-navigation.service";

@Component({
  selector: 'sm-error-dialog',
  templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {

  error?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public model: string,
    private newNavigationService: NewNavigationService
  ) {
    if (isDevMode())
      this.error = this.model;
  }

  onSubmit() {
    this.newNavigationService.toLogout();
  }

}
